export default __webpack_public_path__ + "static/media/36I-102791_-15924_0.d45a0497.jpg";